<div class="ui-modal" [dir]="direction">
  <div class="header flex-row space-between-center">
    {{variable ? ('VARIABLES.BUTTONS.UPDATE' | translate) : 'VARIABLES.BUTTONS.CREATE' | translate}}
    <span class="ui-icon-close c-p" mat-dialog-close></span>
  </div>
  <div class="body flex-col gap-24" [formGroup]="form">
    <div class="flex-col gap-8 w-100">
      <div>{{ 'VARIABLES.TABLE.NAME' | translate }}</div>
      <input
        class="ui-input"
        formControlName="name"
        [placeholder]="'VARIABLES.TABLE.NAME' | translate"
      />
      <div *ngxControlError="form.controls.name; track: 'nameExists'" class="error-msg">
        {{ 'CREATE_VARIABLE_MODAL.NAME_EXIST' | translate }}
      </div>
    </div>
    <div class="flex-col gap-8 w-100">
      <div>{{ 'VARIABLES.TABLE.TYPE' | translate }}</div>
      <mat-select placeholder="Select a type" class="ui-selector" [formControl]="form.controls.type">
        <mat-option value="int">Int</mat-option>
        <mat-option value="string">String</mat-option>
        <mat-option value="json">Json</mat-option>
        <mat-option value="float">Float</mat-option>
      </mat-select>
    </div>
    <div class="flex-col gap-8 w-100">
      <div>{{ 'VARIABLES.TABLE.VALUE' | translate }}</div>
      @switch (form.controls.type.value) {
        @case ('string') {
          <input
            class="ui-input"
            formControlName="value"
            [placeholder]="'CREATE_VARIABLE_MODAL.PLACEHOLDERS.STRING' | translate"
          />
        }
        @case ('int') {
          <input
            class="ui-input"
            formControlName="value"
            [placeholder]="'CREATE_VARIABLE_MODAL.PLACEHOLDERS.INT_ONLY' | translate"
            appIntegerOnly
          />
        }
        @case ('float') {
          <input
            type="text"
            class="ui-input"
            formControlName="value"
            [placeholder]="'CREATE_VARIABLE_MODAL.PLACEHOLDERS.FLOAT_ONLY' | translate"
            appFloatOnly
          />
        }
        @case ('json') {
          <ngx-monaco-editor
            class="json-editor"
            (onInit)="onInit($event)"
            [options]="editorOptions()"
            formControlName="value"
          ></ngx-monaco-editor>
        }
      }
    </div>
  </div>
  <div class="footer flex-row end-center gap-8">
    <ui-button
      type="primary"
      [disabled]="form.invalid"
      [text]="!variable ? ('COMMON.ADD' | translate) : 'COMMON.EDIT' | translate"
      (clickAction)="onAdd()"
    ></ui-button>
  </div>
</div>
